import Container from '@mui/material/Container';
import { PageHelmet } from '../components';
import { PAGES_ANALYTICS_TITLES } from '../utils/enums';
import { Payroll } from '../features/payroll';

const PayrollPage = () => (
  <PageHelmet title={PAGES_ANALYTICS_TITLES.PAYROLL}>
    <Container
      sx={{
        pt: 2,
        px: { xs: 1, lg: 2 },
      }}
      maxWidth={false}
    >
      <Payroll />
    </Container>
  </PageHelmet>
);

export default PayrollPage;
